import { useEffect, useState } from 'react'

import isImageValid from '@/utils/isImageValid'

const IMAGES_FORMATS = {
  small: 'logo_csquarred',
  big: 'logo_website_squarred'
}

function getFormattedImageUrl(pictureUrl: string | null | undefined, format: 'small' | 'big'): string | undefined {
  if (!pictureUrl) return undefined

  return pictureUrl.replace(/(\.[a-z]+)$/i, `.${IMAGES_FORMATS[format]}$1`)
}

export default function useOfferImage(pictureUrl: string | null | undefined): string | undefined {
  const [smallImageValid, setSmallImageValid] = useState<boolean | undefined>(undefined)
  const [bigImageValid, setBigImageValid] = useState<boolean>(false)

  const smallImageUrl = getFormattedImageUrl(pictureUrl, 'small')
  const bigImageUrl = getFormattedImageUrl(pictureUrl, 'big')

  useEffect(() => {
    setSmallImageValid(undefined)
    setBigImageValid(false)

    if (!smallImageUrl) return

    const prefetchAndCheckImages = async () => {
      const isSmallValid = await isImageValid(smallImageUrl)
      setSmallImageValid(isSmallValid)

      if (bigImageUrl) {
        const isBigValid = await isImageValid(bigImageUrl)
        setBigImageValid(isBigValid)
      }
    }

    prefetchAndCheckImages()
  }, [smallImageUrl, bigImageUrl])

  const getBackgroundStyle = () => {
    if (!smallImageUrl) return undefined

    if (smallImageValid && bigImageValid && bigImageUrl) {
      return `url(${bigImageUrl}), url(${smallImageUrl})`
    } else if (smallImageValid) {
      return `url(${smallImageUrl})`
    } else if (bigImageValid && bigImageUrl) {
      return `url(${bigImageUrl})`
    }

    return undefined
  }

  return getBackgroundStyle()
}
